<template>
	<div class="topic-level-cate">
		<div class="row" style="margin-bottom: 20px;">
			<div class="col-xl-6">课题级别类别</div>
			<div class="col-xl-6" style="display: flex;justify-content: flex-end;align-items: center;"><Breadcrumb></Breadcrumb></div>
		</div>

		<el-card>
			<el-table
				:data="topicLevelTableData"
				style="width: 100%;margin-bottom: 20px;"
				row-key="id"
				border
				default-expand-all
				:tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
			>
				<el-table-column prop="name" label="课题类别名称" sortable width="180"></el-table-column>
				<el-table-column prop="level" label="层级" sortable width="180"></el-table-column>
				<el-table-column prop="remark" label="备注"></el-table-column>
				<el-table-column label="管理">
					<template slot-scope="scope">
						<el-button style="margin-right: 20px;" size="small" type="primary" @click="openDialog('修改', scope.row)">修改</el-button>
						<el-popconfirm title="确定删除吗？" @confirm="delConfirm(scope.row.id)"><el-button slot="reference" size="small" type="danger">删除</el-button></el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<div class="btn-wrap"><el-button size="small" type="primary" @click="openDialog('新增')">添加</el-button></div>
		</el-card>

		<!-- 添加课题类别对话框 -->
		<el-dialog :title="dialogTitle" :visible.sync="topicCateDialogVisible" width="30%" :close-on-click-modal="false">
			<div class="topic-cate">
				<el-form :model="topicCateForm" :rules="rules" ref="topicCateForm" label-width="100px" class="demo-ruleForm">
					<el-form-item label="上级目录" prop="parentId">
						<el-select v-model="topicCateForm.parentId" clearable placeholder="请选择">
							<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="名称" prop="dictName"><el-input v-model="topicCateForm.dictName"></el-input></el-form-item>
					<el-form-item label="描述" prop="remark">
						<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入描述" v-model="topicCateForm.remark" maxlength="200" show-word-limit></el-input>
					</el-form-item>
				</el-form>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="topicCateDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="changeTopicLevelCate">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
import { getPlatformInformationData, addPlatformInformationData, delPlatformInformationData, editPlatformInformationData } from '@/api/after/systemManagement.js';
export default {
	components: {
		Breadcrumb
	},
	data() {
		return {
			dialogTitle: '新增',
			topicCateForm: {
				dictTypeId: 1,
				parentId: '',
				dictName: '',
				remark: ''
			},
			rules: {
				parentId: [{ required: false, message: '请选择课题级别', trigger: 'change' }],
				dictName: [{ required: true, message: '请输入课题级别类别名称', trigger: 'blur' }]
			},
			topicCateDialogVisible: false,
			topicLevelTableData: [],
			options: []
		};
	},
	created() {
		this.getPlatformInformationData();
	},
	methods: {
		// 获取课题级别类别目录
		async getPlatformInformationData() {
			const res = await getPlatformInformationData(1);
			console.log('课题级别类别', res);
			if (res.code == 200) {
				this.options = res.data;
				this.topicLevelTableData = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		// 添加课题级别类别
		async addPlatformInformationData() {
			
			// 防止同级别中名称相同开始
			let isRepeat = true;
			if (this.topicCateForm.parentId === 0) {
				//创建一级类别名称时
				console.log('一级类别', this.topicCateForm);
				if (this.topicLevelTableData.length) {
					isRepeat = this.topicLevelTableData.some(item => {
						return item.name === this.topicCateForm.dictName;
					});
				} else {
					//如果一级列表没有东西
					isRepeat = false;
				}
			} else {
				//创建二级类别名称时
				console.log('二级类别', this.topicCateForm);
				let parentObj = this.topicLevelTableData.find(item => {
					return item.id == this.topicCateForm.parentId;
				});
				if (parentObj.children && parentObj.children.length > 0) {
					isRepeat = parentObj.children.some(item => {
						return item.name === this.topicCateForm.dictName;
					});
				} else {
					isRepeat = false;
				}
			}
			if (isRepeat) {
				return this.$message.error('同级别名称不能相同！');
			}
			
			const res = await addPlatformInformationData(this.topicCateForm);
			if (res.code == 200) {
				this.topicCateDialogVisible = false;
				this.$refs.topicCateForm.resetFields();
				this.getPlatformInformationData();
			} else {
				this.$message.error(res.data);
			}
		},
		// 删除课题级别类别
		async delPlatformInformationData(id) {
			const res = await delPlatformInformationData(id);
			if (res.code == 200) {
				this.getPlatformInformationData();
			} else {
				this.$message.error(res.data);
			}
		},
		// 修改课题级别类别
		async editPlatformInformationData() {
			
			// 防止同级别中名称相同开始
			let isRepeat = false;
			if (this.topicCateForm.parentId === 0) {
				//创建一级类别名称时
				console.log('一级类别', this.topicCateForm);
				if (this.topicLevelTableData.length) {
					isRepeat = this.topicLevelTableData.some(item => {
						return (item.name === this.topicCateForm.dictName) && (item.id !== this.topicCateForm.id)
					});
				} else {
					//如果一级列表没有东西
					isRepeat = false;
				}
			} else {
				//创建二级类别名称时
				console.log('二级类别', this.topicCateForm);
				let parentObj = this.topicLevelTableData.find(item => {
					return item.id == this.topicCateForm.parentId;
				});
				if (parentObj.children && parentObj.children.length > 0) {
					isRepeat = parentObj.children.some(item => {
						return (item.name === this.topicCateForm.dictName) && (item.id !== this.topicCateForm.id)
					});
				} else {
					isRepeat = false;
				}
			}
			if (isRepeat) {
				return this.$message.error('同级别名称不能相同！');
			}

			let params = {
				...this.topicCateForm,
				dictTypeId: 1
			};
			const res = await editPlatformInformationData(params);
			if (res.code == 200) {
				this.topicCateDialogVisible = false;
				this.$refs.topicCateForm.resetFields();
				this.getPlatformInformationData();
			} else {
				this.$message.error(res.data);
			}
		},
		// 添加或者修改课题级别类别
		changeTopicLevelCate() {
			this.$refs.topicCateForm.validate(valid => {
				if (valid) {
					// 如果没有选择上级目录,则创建一级目录
					if (this.topicCateForm.parentId === '') {
						this.topicCateForm.parentId = 0;
					}

					

					// 防止同级别中名称相同结束
					if (this.dialogTitle === '新增') {
						if (this.topicCateForm.parentId === '') {
							this.topicCateForm.parentId = 0;
						}
						this.addPlatformInformationData();
					} else {
						this.editPlatformInformationData();
					}
				} else {
					this.$message.error('没有通过表单验证');
				}
			});
		},
		// 递归获取当前添加课题的父级课题对象
		// notRepeat(arr,val){
		// 	for(let i=0; i<arr.length; i++){
		// 		if (arr[i].id == val) {
		// 			return arr[i]
		// 		}else{
		// 			if (arr[i].children && arr[i].children.length > 0) {
		// 				this.notRepeat(arr[i].children, val)
		// 			}
		// 		}
		// 	}
		// },
		// 确认删除
		delConfirm(id) {
			this.delPlatformInformationData(id);
		},
		// 添加课题类别
		openDialog(actionType, data) {
			this.dialogTitle = actionType;
			if (data) {
				data.dictName = data.name;
				this.topicCateForm = JSON.parse(JSON.stringify(data));
				console.log(this.topicCateForm);
			}else{//新增初始化表单值
				this.topicCateForm = {
					dictTypeId: 1,
					parentId: '',
					dictName: '',
					remark: ''
				}
			}
			this.topicCateDialogVisible = true;
		}
	}
};
</script>

<style scoped></style>
